module.exports = __webpack_public_path__ + "static/img/bg6.6a4c8b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/year2023/bg6.png
// module id = o+zg
// module chunks = 0